<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container">
      <div class="section">

        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li><a @click="$router.push('/clients')">{{ CONSTANTS.getCopy('SENTENCESANDANSWERS_BREADCRUMB_CHATBOTS') }}</a></li>
            <li><a @click="$router.push('/clients/' + client + '/intents')">{{ clientName }}</a></li>
            <li><a @click="$router.go()">{{ intentName }}</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('SENTENCESANDANSWERS_BREADCRUMB_PHRASES_ANSWERS') }}</a></li>
          </ul>
        </nav>

        <br>

        <!-- TABS -->
        <div class="tabs is-boxed is-fullwidth">
          <ul>
            <li :class="{ 'is-active': isActiveTab('sentences') }" @click="showTab('sentences')">
              <a>
                <span class="icon is-small"><i class="fas fa-comments" aria-hidden="true"></i></span>
                <span>{{ CONSTANTS.getCopy('SENTENCESANDANSWERS_TABS_PHRASES') }}</span>
              </a>
            </li>
            <li v-if="!defaultIntent" :class="{ 'is-active': isActiveTab('common-answers') }" @click="showTab('common-answers')">
              <a>
                <span class="icon is-small"><i class="fas fa-comment-dots" aria-hidden="true"></i></span>
                <span>{{ CONSTANTS.getCopy('SENTENCESANDANSWERS_COMMON_ANSWERS') }}</span>
              </a>
            </li>
            <li v-if="!defaultIntent" :class="{ 'is-active': isActiveTab('default-answers') }" @click="showTab('default-answers')">
              <a>
                <span class="icon is-small"><i class="fas fa-comment" aria-hidden="true"></i></span>
                <span>{{ CONSTANTS.getCopy('SENTENCESANDANSWERS_DEFAULT_ANSWERS') }}</span>
              </a>
            </li>
          </ul>
        </div>

        <sentences v-if="isActiveTab('sentences')"></sentences>
        <answers v-if="isActiveTab('common-answers') || isActiveTab('default-answers')" :typeAnswer="typeAnswer"></answers>

      </div>
    </div>
  </div>
</template>

<script>
import Sentences from './sentences/Sentences'
import Answers from './commonAndDefaultAnswers/Answers'
import AnswerTypes from '../../../lib/AnswerTypes'

export default {
  components: { Sentences, Answers },
  data () {
    return {
      activeTab: 'sentences',
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intent: this.$route.params.intent,
      intentName: 'Intención',
      defaultIntent: true,
      sentence: this.$route.params.sentence,
      typeAnswer: 0
    }
  },
  created () {
    this.breadcrumbDetails()
    // this.activeTab = this.$route.query.tab ? this.$route.query.tab : 'sentences'
  },
  methods: {
    breadcrumbDetails () {
      this.api.post('/ClientById/', { idClient: this.client }).then(response => {
        this.clientName = response.client.name
      })
      this.api.post('/IntentById', { idIntent: this.$route.params.intent }).then(response => {
        this.intentName = response.intent.name
        this.defaultIntent = this.intentName.toLowerCase() === 'default'
        this.activeTab = this.$route.query.tab && !this.defaultIntent ? this.$route.query.tab : 'sentences'
        if (localStorage.getItem('answerView')) {
          this.showTab(localStorage.getItem('answerView'))
          localStorage.removeItem('answerView')
        }
      })
    },
    showTab (tab) {
      this.activeTab = tab
      if (tab === 'common-answers') {
        this.typeAnswer = AnswerTypes.COMMON
        return
      }
      if (tab === 'default-answers') {
        this.typeAnswer = AnswerTypes.DEFAULT
        return
      }
      this.typeAnswer = AnswerTypes.SENTENCE
    },
    isActiveTab (tab) {
      return this.activeTab === tab
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/SentencesAndAnswers.vue